import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Pagination, Snackbar, SnackbarCloseReason } from "@mui/material";
import DeleteDescription from "./delete-desc";
import { DeleteDescriptionServ, DeleteDescriptionsServ, DeleteTemplateServ, GetPropertyDesc, GetTemplatesDesc, UpdateTemplateServ, UploadCsvTemplates } from "../../Services/DescriptionTitle";
import ViewDescription from "./view-description";
import SortByDescAndTemplate from "./sortBy-desc-template";
import { SortByObj } from "../../Models/SortByObj";
import UpdateTemplate from "./update-template";
import { useTranslation } from "react-i18next";

const AIDescriptionTitle: React.FunctionComponent<{}> = (props) => {

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [colorSnackbar, setColorSnackbar] = useState<any>("");
    const [message, setMessage] = useState<string>();
    const [listDescription, setListDescription] = useState<any>([]);
    const [listTemplate, setListTemplate] = useState<any>([]);
    const [isChange, setIsChange] = useState<boolean>(false);
    const navigate = useNavigate();
    const [selectedDescriptions, setSelectedDescriptions] = useState<any>([]);
    const [filterDescValue, setFilterDescValue] = useState<SortByObj>({});
    const [filterTemplateValue, setFilterTemplateValue] = useState<SortByObj>({});
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [isUpload, setIsUpload] = useState<boolean>(false);
    const [pageNumberDesc, setPageNumberDesc] = useState<number>(1);
    const [totalPageDesc, setTotalPageDesc] = useState<number>(1);
    const [descriptionsLenght, setDescriptionLenght] = useState<any>();
    const [isLoadingDesc, setLoadingDesc] = useState<boolean>(true);
    const [pageNumberTemplate, setPageNumberTemplate] = useState<number>(1);
    const [totalPageTemplate, setTotalPageTemplate] = useState<number>(1);
    const [templatesLenght, setTemplatesLenght] = useState<any>();
    const [isLoadingTemplate, setLoadingTemplate] = useState<boolean>(true);
    const { t } = useTranslation();

    useEffect(() => {
        GetPropertyDesc(filterDescValue, pageNumberDesc).then(resp => {
            setListDescription(resp.data)
            setTotalPageDesc(Math.ceil(resp.total / 8))
            setDescriptionLenght(resp.total)
            setLoadingDesc(false)
        }).catch(error => {
            console.log("error")
        })
    }, [isChange, filterDescValue])

    useEffect(() => {
        GetTemplatesDesc(filterTemplateValue, pageNumberTemplate).then(resp => {
            setListTemplate(resp.data)
            setTotalPageTemplate(Math.ceil(resp.total / 8))
            setTemplatesLenght(resp.total)
            setLoadingTemplate(false)
        }).catch(error => {
            console.log("error")
        })
    }, [isChange, filterTemplateValue])

    const GenerateDesc = () => {
        navigate("generate-description")
    }

    const capitalizeFirstLetter = (word: any) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }

    const capitalizeWordsInSentence = (offeringType: any) => {
        const offeringTypeValue = offeringType.replace('-', ' ')
        const words = offeringTypeValue.split(' ');
        const capitalizedWords = words.map(capitalizeFirstLetter);
        return capitalizedWords.join(' ');
    }

    const isSelected = (propertyId: any) => selectedDescriptions.includes(propertyId);

    const handleSelectAllDescriptions = (e: any) => {
        if (e.target.checked) {
            const allIds: any = listDescription.map((property: any) => property._id);
            setSelectedDescriptions(allIds);
        } else {
            setSelectedDescriptions([]);
        }
    }

    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    }

    const convertDate = (date: any) => {
        const dateTime = new Date(date);
        const day = dateTime.getDate().toString().padStart(2, '0');
        const month = (dateTime.getMonth() + 1).toString().padStart(2, '0');
        const year = dateTime.getUTCFullYear().toString();
        const formattedDate = `${day}/${month}/${year}`;
        return formattedDate;
    }

    const DropTemplate = (id: any) => {
        DeleteTemplateServ(id).then(resp => {
            setIsChange(!isChange)
            setColorSnackbar("success")
            setOpenSnackbar(true)
            setMessage("Template deleted successfully !")
        }).catch(error => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage("Failed to delete template.")
        })
    }

    const DropDescriptions = () => {
        DeleteDescriptionsServ(selectedDescriptions).then(resp => {
            setIsChange(!isChange)
            setColorSnackbar("success")
            setOpenSnackbar(true)
            setMessage("Descriptions deleted successfully !")
        }).catch(error => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage("Failed to delete templates.")
        })
    }

    const DropDescription = (id: any) => {
        DeleteDescriptionServ(id).then(resp => {
            setIsChange(!isChange)
            setColorSnackbar("success")
            setOpenSnackbar(true)
            setMessage("Description deleted successfully !")
        }).catch(error => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage("Failed to delete description.")
        })
    }

    const changeMessageHandler = (color: string, msg: string) => {
        setColorSnackbar(color)
        setOpenSnackbar(true)
        setMessage(msg)
    }

    const handleSelectProperty = (propertyId: any) => {
        setSelectedDescriptions((prevSelected: any) => {
            if (prevSelected.includes(propertyId)) {
                return prevSelected.filter((id: any) => id !== propertyId);
            } else {
                return [...prevSelected, propertyId];
            }
        });
    }

    const handleChangeSortByDesc = (value: any) => {
        // setFilterDescValue(value);
        // setIsChange(!isChange);
    }

    const handleChangeSortByTemplate = (value: any) => {
        setFilterTemplateValue(value);
        setIsChange(!isChange);
    }

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        UploadCsvTemplates(file).then(resp => {
            setIsChange(!isChange)
            setIsUpload(false)
            setColorSnackbar("success")
            setOpenSnackbar(true)
            setMessage("Template added successfully !")
        }).catch(error => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage(error.response.data.error)
        })
    }

    const UpdateTemplateHandler = (template: any, id: any) => {
        UpdateTemplateServ(template, id).then(resp => {
            setIsChange(!isChange)
            setIsUpload(false)
            setColorSnackbar("success")
            setOpenSnackbar(true)
            setMessage("Template updated successfully !")
        }).catch(error => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage(error.response.data.error)
        })
    }

    const handleChangePaginationDesc = (event: React.ChangeEvent<unknown>, value: number) => {
        setPageNumberDesc(value)
        setIsChange(!isChange)
    }

    const handleChangePaginationTemplate = (event: React.ChangeEvent<unknown>, value: number) => {
        setPageNumberTemplate(value)
        setIsChange(!isChange)
    }


    return (
        <div className="container-xxl flex-grow-1 marg-bottom-50">
            <div className="row align-items-center mt-4">
                <div className="col-4 col-auto-mb mb-4">
                    <a href="/properties" className="buuton-next border-trans back-EEF2FF border-9">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 14L13 7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 7" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14H22.3333" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14H22.3333" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 21" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 21" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </a>
                </div>
                <div className="col-4 text-center col-auto-mb mb-4">
                    <h1 className="title-24 title-20-mb color-black mb-2">{t("aiDescTitle.headerTitle")}</h1>
                    <p className="para-16 color-39393B">{t("aiDescTitle.headerSubtitle")}</p>
                </div>
                <div className="col-md-4 text-end text-center-mb mb-4">
                    <button onClick={GenerateDesc} className="button-dash back-746AFF border-8 color-FFFFFF padd-15-mb  bold-600 border-746AFF padd-20" >
                        {t("aiDescTitle.generateNewDescription")}
                    </button>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-6 padd-10">
                    <div className="d-flex justify-content-between align-items-center">
                        <h1 className="title-24 title-18-mb color-black mb-2">{t("generateDescTitle.description")}</h1>
                        <button className={`bg-label-danger padd-10 border-EF4444 border-6 ${selectedDescriptions.length > 1 ? "" : "disabled"}`} onClick={DropDescriptions}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_1117_1995)">
                                    <path d="M4 7H20" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10 11V17" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M14 11V17" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M5 7L6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19L19 7" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M9 7V4C9 3.73478 9.10536 3.48043 9.29289 3.29289C9.48043 3.10536 9.73478 3 10 3H14C14.2652 3 14.5196 3.10536 14.7071 3.29289C14.8946 3.48043 15 3.73478 15 4V7" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1117_1995">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                    <div className="card border-12 border-0-2 mb-4 mt-4">
                        <div className="table-responsive text-nowrap" style={{ borderRadius: "12px 12px 0px 0px" }}>
                            <table className="table">
                                <thead className="color-FFFFFF table-back-6366F1 padd-10" >
                                    <tr>
                                        <th className="width-80">
                                            <input type="checkbox" className="form-check-input border-FFFFFF back-trans"
                                                onChange={handleSelectAllDescriptions} checked={selectedDescriptions.length === listDescription.length} />
                                        </th>
                                        <th className="para-14 bold-600">
                                            {t("propertiesPage.id")}
                                            <SortByDescAndTemplate filterOptionsValue={filterDescValue} OnSelectChangeSortBy={handleChangeSortByDesc} thead="idProperty" />

                                        </th>
                                        <th className="para-14 bold-600">
                                            {t("propertiesPage.property")}
                                        </th>
                                        <th className="para-14 bold-600">
                                            {t("propertyDetails.offeringType")}
                                            <SortByDescAndTemplate filterOptionsValue={filterDescValue} OnSelectChangeSortBy={handleChangeSortByDesc} thead="offeringType" />
                                        </th>
                                        <th className="para-14 bold-600">
                                            {t("aiDescTitle.dateCreated")}
                                            <SortByDescAndTemplate filterOptionsValue={filterDescValue} OnSelectChangeSortBy={handleChangeSortByDesc} thead="createdAt" />
                                        </th>
                                        <th className="para-14 bold-600">
                                            {t("propertiesPage.actions")}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="table-tbody">
                                    {listDescription.map((lines: any, index: any) => {
                                        return <tr key={"line_" + index} >
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input  border-black"
                                                    checked={isSelected(lines._id)}
                                                    onChange={() => handleSelectProperty(lines._id)}
                                                />
                                            </td>
                                            <td>{lines.description.idProperty}</td>
                                            <td>
                                                <svg width="16" height="16" className="marg-right-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clipPath="url(#clip0_1117_2020)">
                                                        <path d="M12.2188 7.65625C12.2188 7.13931 11.7982 6.71875 11.2812 6.71875H10.3438C9.82681 6.71875 9.40625 7.13931 9.40625 7.65625V10.9375H12.2188V7.65625Z" fill="black" fillOpacity="0.8" />
                                                        <path d="M1.90625 2.34375C1.90625 1.56844 2.53719 0.9375 3.3125 0.9375H4.25C4.88356 0.9375 5.4205 1.35888 5.59575 1.936C4.55756 2.17669 3.78125 3.10844 3.78125 4.21875V4.6875H8.46875V4.21875C8.46875 3.07288 7.64197 2.11709 6.55375 1.915C6.35166 0.826687 5.39575 0 4.25 0H3.3125C2.02031 0 0.96875 1.05125 0.96875 2.34375V6.71875H1.90625V2.34375Z" fill="black" fillOpacity="0.8" />
                                                        <path d="M13.1562 11.875H8.46875V10.4688H0.96875V11.875C0.96875 13.1016 1.64531 14.1729 2.64475 14.7359L2.04356 15.3371L2.70644 16L3.61253 15.0939C3.81881 15.1347 4.03194 15.1562 4.25 15.1562H11.75C11.9681 15.1562 12.1812 15.1347 12.3875 15.0939L13.2936 16L13.9565 15.3371L13.3553 14.7359C14.3547 14.1729 15.0312 13.1016 15.0312 11.875V10.4688H13.1562V11.875Z" fill="black" fillOpacity="0.8" />
                                                        <path d="M15.0625 7.65625H13.1562V9.53125H15.0625C15.5794 9.53125 16 9.11063 16 8.59375C16 8.07687 15.5794 7.65625 15.0625 7.65625Z" fill="black" fillOpacity="0.8" />
                                                        <path d="M8.46875 7.65625H0.9375C0.420625 7.65625 0 8.07687 0 8.59375C0 9.11063 0.420625 9.53125 0.9375 9.53125H8.46875V7.65625Z" fill="black" fillOpacity="0.8" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_1117_2020">
                                                            <rect width="16" height="16" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                {lines.description.bathroom ? lines.description.bathroom : ""}
                                                <svg width="16" height="16" className="marg-left-10 marg-right-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.5 7.20938C13.1848 7.071 12.8442 6.9997 12.5 7H3.5C3.15578 6.99967 2.81525 7.07086 2.5 7.20906C2.05444 7.40391 1.67529 7.72435 1.4089 8.1312C1.14252 8.53805 1.00043 9.0137 1 9.5V13C1 13.1326 1.05268 13.2598 1.14645 13.3536C1.24021 13.4473 1.36739 13.5 1.5 13.5C1.63261 13.5 1.75979 13.4473 1.85355 13.3536C1.94732 13.2598 2 13.1326 2 13V12.75C2.00081 12.6839 2.02741 12.6208 2.07412 12.5741C2.12083 12.5274 2.18395 12.5008 2.25 12.5H13.75C13.8161 12.5008 13.8792 12.5274 13.9259 12.5741C13.9726 12.6208 13.9992 12.6839 14 12.75V13C14 13.1326 14.0527 13.2598 14.1464 13.3536C14.2402 13.4473 14.3674 13.5 14.5 13.5C14.6326 13.5 14.7598 13.4473 14.8536 13.3536C14.9473 13.2598 15 13.1326 15 13V9.5C14.9995 9.01375 14.8574 8.53817 14.591 8.13138C14.3246 7.72459 13.9455 7.4042 13.5 7.20938Z" fill="black" fillOpacity="0.8" />
                                                    <path d="M11.75 2.5H4.25C3.78587 2.5 3.34075 2.68437 3.01256 3.01256C2.68437 3.34075 2.5 3.78587 2.5 4.25V6.5C2.50001 6.51937 2.50453 6.53847 2.51319 6.5558C2.52185 6.57313 2.53442 6.5882 2.54991 6.59984C2.56539 6.61148 2.58337 6.61935 2.60242 6.62285C2.62147 6.62635 2.64108 6.62538 2.65969 6.62C2.93264 6.54017 3.21561 6.49976 3.5 6.5H3.63219C3.66304 6.5002 3.69288 6.48897 3.71595 6.46849C3.73903 6.44801 3.75372 6.41972 3.75719 6.38906C3.78446 6.14475 3.90077 5.91904 4.0839 5.75504C4.26704 5.59104 4.50417 5.50025 4.75 5.5H6.5C6.74599 5.50002 6.98335 5.59071 7.16668 5.75473C7.35002 5.91875 7.46646 6.14459 7.49375 6.38906C7.49722 6.41972 7.51191 6.44801 7.53498 6.46849C7.55806 6.48897 7.5879 6.5002 7.61875 6.5H8.38313C8.41398 6.5002 8.44381 6.48897 8.46689 6.46849C8.48997 6.44801 8.50465 6.41972 8.50813 6.38906C8.53538 6.14491 8.65155 5.91933 8.83449 5.75535C9.01743 5.59138 9.25433 5.50048 9.5 5.5H11.25C11.496 5.50002 11.7334 5.59071 11.9167 5.75473C12.1 5.91875 12.2165 6.14459 12.2437 6.38906C12.2472 6.41972 12.2619 6.44801 12.285 6.46849C12.3081 6.48897 12.3379 6.5002 12.3687 6.5H12.5C12.7844 6.49986 13.0674 6.54038 13.3403 6.62031C13.3589 6.6257 13.3786 6.62667 13.3977 6.62315C13.4167 6.61964 13.4347 6.61173 13.4502 6.60006C13.4657 6.58839 13.4783 6.57327 13.4869 6.5559C13.4956 6.53854 13.5 6.5194 13.5 6.5V4.25C13.5 3.78587 13.3156 3.34075 12.9874 3.01256C12.6592 2.68437 12.2141 2.5 11.75 2.5Z" fill="black" fillOpacity="0.8" />
                                                </svg>
                                                {lines.description.bedroom ? lines.description.bedroom : ""}
                                                <svg width="16" height="16" className="marg-left-10 marg-right-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.9565 2.02497C12.8737 1.9145 12.8961 1.7578 13.0066 1.67499C13.117 1.59216 13.2737 1.61459 13.3565 1.72506L14.1999 2.85006C14.2665 2.93892 14.2665 3.0611 14.1999 3.14997L13.3565 4.27497C13.2737 4.38545 13.117 4.40786 13.0066 4.32505C12.8961 4.24222 12.8737 4.08554 12.9565 3.97506L13.5 3.25001H5.76862L6.34152 3.96926C6.42753 4.07725 6.40972 4.23453 6.30172 4.32056C6.19373 4.40658 6.03644 4.38877 5.95042 4.28077L5.05433 3.15577C4.98173 3.06462 4.98173 2.9354 5.05433 2.84426L5.95042 1.71926C6.03644 1.61126 6.19373 1.59344 6.30172 1.67946C6.40972 1.76549 6.42753 1.92277 6.34152 2.03077L5.76862 2.75001H13.5L12.9565 2.02497Z" fill="black" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M14.25 5.56252C14.25 5.28638 14.0261 5.06252 13.75 5.06252H5.4375C5.16136 5.06252 4.9375 5.28638 4.9375 5.56252V14C4.9375 14.2761 5.16136 14.5 5.4375 14.5H13.75C14.0261 14.5 14.25 14.2761 14.25 14V5.56252ZM5.4375 5.56252H13.75V14H5.4375V5.56252Z" fill="black" />
                                                    <path d="M4.07502 13.2566C3.9922 13.1463 3.83549 13.1238 3.72502 13.2066L2.99998 13.7501V6.01877L3.71922 6.59165C3.82722 6.67768 3.98451 6.65987 4.07053 6.55187C4.15656 6.44387 4.13875 6.28658 4.03075 6.20055L2.90573 5.30447C2.81461 5.23187 2.68536 5.23187 2.59423 5.30447L1.46923 6.20055C1.36123 6.28658 1.34336 6.44387 1.42948 6.55187C1.51548 6.65987 1.67273 6.67768 1.78073 6.59165L2.49998 6.01877V13.7501L1.77498 13.2066C1.66448 13.1238 1.50773 13.1463 1.42498 13.2566C1.34211 13.3671 1.36461 13.5239 1.47498 13.6066L2.59998 14.45C2.68886 14.5166 2.81111 14.5166 2.89998 14.45L4.02494 13.6066C4.13542 13.5239 4.15783 13.3671 4.07502 13.2566Z" fill="black" />
                                                </svg>
                                                {lines.description.size.builtUpSize ? Number(lines.description.size.builtUpSize).toLocaleString("en-US") : ""}
                                                {lines.description.size.unitBuiltUp ? lines.description.size.unitBuiltUp.replace(/\s+/g, '').toLowerCase() : ""}
                                            </td>
                                            <td>{capitalizeWordsInSentence(lines.description.offeringType)}</td>
                                            <td>{convertDate(lines.createdAt)}</td>
                                            <td className="actions">

                                                <DeleteDescription Id={lines._id} name={"Description"} onDeleteDescription={DropDescription} />
                                                <ViewDescription property={lines.description} onChangeMessage={changeMessageHandler} />

                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex justify-content-center mb-4">
                            {descriptionsLenght == 0 && isLoadingDesc == false && <h3 className="empty"> {t("aiDescTitle.noDescriptions")} </h3>}

                            {isLoadingDesc == true ? <div className="row ">
                                <div className="col-auto">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                                : descriptionsLenght !== 0 && <Pagination count={totalPageDesc} variant="outlined" shape="rounded" onChange={handleChangePaginationDesc} />}
                        </div>
                    </div>
                </div>
                <div className="col-md-6 padd-10">
                    <div className="d-flex justify-content-between align-items-center">
                        <h1 className="title-24 title-18-mb color-black mb-2">{t("generateDescTitle.templates")}</h1>
                        <div>
                            <button
                                className="button-reset border-746AFF padd-15-mb color-746AFF back-EEF2FF padd-15-30"
                                onClick={() => fileInputRef.current?.click()}>
                                {t("propertyDetails.uploadTemplate")}
                                {isUpload && <div className="spinner-border size-20 text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>}
                            </button>
                            <input
                                type="file"
                                accept=".csv"
                                ref={fileInputRef}
                                onChange={handleFileUpload}
                                style={{ display: "none" }}
                            />
                        </div>
                    </div>
                    <div className="card border-12 border-0-2 mt-4">
                        <div className="table-responsive text-nowrap" style={{ borderRadius: "12px 12px 0px 0px" }}>
                            <table className="table">
                                <thead className="color-FFFFFF table-back-6366F1 padd-10" >
                                    <tr>
                                        <th className="para-14 bold-600">
                                            {t("home.name")}
                                            <SortByDescAndTemplate filterOptionsValue={filterDescValue} OnSelectChangeSortBy={handleChangeSortByTemplate} thead="name" />
                                        </th>
                                        <th className="para-14 bold-600">
                                            {t("descriptionDetails.style")}
                                            <SortByDescAndTemplate filterOptionsValue={filterDescValue} OnSelectChangeSortBy={handleChangeSortByTemplate} thead="style" />
                                        </th>
                                        <th className="para-14 bold-600">
                                            {t("descriptionDetails.tone")}
                                            <SortByDescAndTemplate filterOptionsValue={filterDescValue} OnSelectChangeSortBy={handleChangeSortByTemplate} thead="tone" />
                                        </th>
                                        <th className="para-14 bold-600">
                                            {t("descriptionDetails.length")}
                                            <SortByDescAndTemplate filterOptionsValue={filterDescValue} OnSelectChangeSortBy={handleChangeSortByTemplate} thead="length" />
                                        </th>
                                        <th className="para-14 bold-600">
                                            {t("aiDescTitle.dateCreated")}
                                            <SortByDescAndTemplate filterOptionsValue={filterDescValue} OnSelectChangeSortBy={handleChangeSortByTemplate} thead="createdAt" />
                                        </th>
                                        <th className="para-14 bold-600">
                                            {t("propertiesPage.actions")}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="table-tbody">
                                    {listTemplate.map((lines: any, index: any) => {
                                        return <tr key={"line_" + index} >
                                            <td>{(lines.name.length > 12) ? lines.name.slice(0, 12) + '...' : lines.name}</td>
                                            <td>{(lines.style.length > 12) ? lines.style.slice(0, 12) + '...' : lines.style}</td>
                                            <td>{(lines.tone.length > 12) ? lines.tone.slice(0, 12) + '...' : lines.tone}</td>
                                            <td>{(lines.length.length > 12) ? lines.length.slice(0, 12) + '...' : lines.length}</td>
                                            <td>{convertDate(lines.createdAt)}</td>
                                            <td className="actions">
                                                <DeleteDescription Id={lines._id} name={"Template"} onDeleteDescription={DropTemplate} />
                                                <UpdateTemplate template={lines} onUpdateTemplate={UpdateTemplateHandler} />

                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex justify-content-center mb-4">
                            {templatesLenght == 0 && isLoadingTemplate == false && <h3 className="empty"> {t("aiDescTitle.noTemplates")}</h3>}

                            {isLoadingTemplate == true ? <div className="row ">
                                <div className="col-auto">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                                : templatesLenght !== 0 && <Pagination count={totalPageTemplate} variant="outlined" shape="rounded" onChange={handleChangePaginationTemplate} />}
                        </div>
                    </div>
                </div>
            </div>

            <Snackbar open={openSnackbar} onClose={handleCloseSnackbar} autoHideDuration={5000}>
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={colorSnackbar || "info"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>

        </div >
    )
}
export default AIDescriptionTitle;